import BaseApi from '../BaseApi';
// 站点左侧接口
export default class SiteApi extends BaseApi {
  // ***************************告警begin***************************
  // 21.获取站点实时告警数据
  async selectStationActualTimeAlarm(info) {
    return await this.get(`screenFaultAlarm/selectStationActualTimeAlarm`, info);
  }
  // 22.获取站点电池仓数据(电池颜色信息前端判断100%，20%-100%，20%以下)
  async selectStationBatteryHolder(info) {
    return await this.get(`screenFaultAlarm/selectStationBatteryHolder`, info);
  }
  // 16.获取移动能源车列表
  async selectStationEnergyVehicles(info) {
    return await this.get(`screenStationInfo/selectStationEnergyVehicles`, info);
  }
  // 17.获取站点告警列表
  async selectStationAlarm(info) {
    return await this.get(`screenStationInfo/selectStationAlarm`, info);
  }
  // 20.获取站点故障率信息
  async selectStationAlarmRateInfo(info) {
    return await this.get(`screenFaultAlarm/selectStationAlarmRateInfo`, info);
  }
  
  // ***************************告警end***************************
}
export const siteRight= new SiteApi();